import React, { Suspense, lazy } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
// Lazy load below-fold sections for faster initial paint
const StorySection = lazy(() => import('./components/StorySection').then(m => ({
  default: m.StorySection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UpsellSection = lazy(() => import('./components/UpsellSection').then(m => ({
  default: m.UpsellSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const UrgencyCloseSection = lazy(() => import('./components/UrgencyCloseSection').then(m => ({
  default: m.UrgencyCloseSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="min-h-screen bg-white font-montserrat selection:bg-neon selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <Suspense fallback={null} data-id="element-5">
          <StorySection data-id="element-6" />
          <ProblemSection data-id="element-7" />
          <SolutionSection data-id="element-8" />
          <BonusSection data-id="element-9" />
          <UpsellSection data-id="element-10" />
          <TestimonialsSection data-id="element-11" />
          <GuaranteeSection data-id="element-12" />
          <FinalCTASection data-id="element-13" />
          <FAQSection data-id="element-14" />
          <UrgencyCloseSection data-id="element-15" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-16">
        <Footer data-id="element-17" />
        <SocialProofPopup data-id="element-18" />
      </Suspense>
    </div>;
}